import React, { useContext } from 'react';
import HeaderNavContext from 'utils/HeaderNavContext';
import backToServiceTitanSvg from './images/back-to-servicetitan.svg';
import { SimpleHeaderContainer } from './styles';

const SimpleHeader = ({ altText = 'Back To ServiceTitan' }) => {
  const { setShowSimpleOrMain } = useContext(HeaderNavContext);

  return (
    <SimpleHeaderContainer
      id="simple-header"
      className="website-simple-header"
      onClick={() => setShowSimpleOrMain(false)}
    >
      <div className="simple-header--link">
        <img loading="lazy" src={backToServiceTitanSvg} alt={altText} />
      </div>
    </SimpleHeaderContainer>
  );
};

export default SimpleHeader;
